import { lastValueFrom } from 'rxjs';
import { GetApplicationSettingsGQL } from '@lib/models/generated/graphql';
import { inject, Injectable, signal } from '@angular/core';
export type ApplicationSettingKey = 'DASHBOARD_MESSAGE' | 'DASHBOARD_MESSAGE_BUTTON' | 'DASHBOARD_MESSAGE_LINK';
export type ApplicationSettings = Record<ApplicationSettingKey, string | null>;
interface ApplicationSettingDto {
  key: string;
  value: string | null;
}
@Injectable({ providedIn: 'root' })
export class ApplicationSettingsService {
  private readonly getApplicationSettingsGQL = inject(GetApplicationSettingsGQL);
  private readonly _appSettings = signal<ApplicationSettings>({
    DASHBOARD_MESSAGE: null,
    DASHBOARD_MESSAGE_BUTTON: null,
    DASHBOARD_MESSAGE_LINK: null,
  });
  public readonly appSettings = this._appSettings.asReadonly();
  public async initApplicationSettings() {
    const result = await lastValueFrom(
      this.getApplicationSettingsGQL.fetch({
        fetchPolicy: 'network-only',
        variables: undefined,
      })
    );
    const dto = result.data!.applicationSettings as ApplicationSettingDto[];
    const settings = this.mapApplicationSettings(dto);
    this._appSettings.set(settings);
  }
  private mapApplicationSettings(settings: ApplicationSettingDto[]): ApplicationSettings {
    const result: Partial<ApplicationSettings> = {};
    for (const setting of settings) {
      const key = setting.key as ApplicationSettingKey;
      result[key] = setting.value;
    }
    return result as ApplicationSettings;
  }
}
